export default __webpack_public_path__ + "e3c0047db75d981141705707d8126033.png";